export function flattenScopes(roleService, orgId, roleIds) {
  const permSet = new Set();
  const roles = roleService ? roleService.findRoles(orgId, roleIds) : [];

  if (roles && roles.length) {
    roles.forEach(role => {
      (role.permissions || []).forEach(p => permSet.add(p));
    });
  } else {
    // Fallback to legacy: treat each roleId itself as a permission
    (roleIds || []).forEach(rid => permSet.add(rid));
  }

  return Array.from(permSet).sort();
}
